/**
 * @ngdoc directive
 * @name runner.flow.users
 * @module flowingly.runner.setup
 * @description  This comppnent is the root for teams
 * @usage
 * ```
     
 * ``` 
 * ### Notes
 * See Also: 
 * ### Properties
 * #### Inputs
 * * users: the list of available users (JSON[])
 */
import { SharedAngular } from '@Client/@types/sharedAngular';

angular.module('flowingly.runner.setup').component('flowUsers', {
  templateUrl:
    'Client/runner.setup/runner.setup.users/runner.setup.users.tmpl.html',
  controller: [
    'sessionService',
    'brandingService',
    function (
      sessionService: SharedAngular.SessionService,
      brandingService: SharedAngular.BrandingService
    ) {
      const $ctrl = this;
      $ctrl.businessName = sessionService.getBusinessName();
      $ctrl.helpUri = brandingService.getBrandedHelpUri(
        'https://help.flowingly.net/administration/how-do-i-add-a-user'
      );
    }
  ]
});
